export default __webpack_public_path__ + "static/media/m71.3b449cf1.png";